/**
 * Matematik ifadelerindeki a/b formatındaki kesirleri HTML kesir formatına dönüştürür.
 * Not: Bu fonksiyon temel kullanım senaryolarına odaklanır (sayılar, değişkenler ve <sup>...</sup> içeren üsler).
 */
export const formatFractions = (text: string): string => {
  if (!text) return '';

  let output = text;

  // 1) Parantez içindeki kesirler: (a/b) veya (2<sup>3</sup>/3<sup>2</sup>) gibi
  //  - Parantezler içindeki pay ve payda için basit bir HTML destekli desen yakalar
  output = output.replace(/\(((?:[^()]+|<[^>]+>)+?)\)\s*\/\s*\(((?:[^()]+|<[^>]+>)+?)\)/g, (_m, num, den) => {
    return `(<span class="fraction"><span class="numerator">${num}</span><span class="denominator">${den}</span></span>)`;
  });

  // 2) Basit kesirler: a/b, 2/3, a<sup>m</sup>/b<sup>n</sup> vb.
  //  - Pay: harf/sayı ile başlar, opsiyonel olarak <sup>...</sup> gelebilir
  //  - Payda: aynı kural
  //  - Basit ve yaygın durumları kapsar; URL'ler ve HTML tag'lerinin içinde eşleşme olasılığı bu içerikte düşüktür
  const simpleFractionRegex = /\b([A-Za-z0-9]+(?:<sup>[^<]*<\/sup>)?)\s*\/\s*([A-Za-z0-9]+(?:<sup>[^<]*<\/sup>)?)\b/g;
  output = output.replace(simpleFractionRegex, (_m, num, den) => {
    return `<span class="fraction"><span class="numerator">${num}</span><span class="denominator">${den}</span></span>`;
  });

  return output;
};

/**
 * React bileşenlerinde kesir formatlı HTML'i güvenli şekilde kullanmak için yardımcı tip.
 * Güvenlik için render öncesi DOMPurify ile sanitize edilmesi önerilir.
 */
export const renderWithFractions = (text: string): { __html: string } => {
  const formatted = formatFractions(text);
  return { __html: formatted };
};